import { useEffect, useState } from "react";
import { CloudOff, RefreshCcw, Check } from "lucide-react";
import { flushQueue, pendingCount } from "@/lib/offline";

export const OfflineBar = () => {
  const [offline, setOffline] = useState(!navigator.onLine);
  const [pending, setPending] = useState(pendingCount());
  const [syncing, setSyncing] = useState(false);

  useEffect(() => {
    const refresh = () => setPending(pendingCount());
    const goOnline = async () => {
      setOffline(false);
      setSyncing(true);
      await flushQueue();
      setSyncing(false);
      refresh();
    };
    const goOffline = () => setOffline(true);
    window.addEventListener("online", goOnline);
    window.addEventListener("offline", goOffline);
    window.addEventListener("gs-queue-change", refresh);
    if (navigator.onLine && pendingCount()) goOnline();
    return () => {
      window.removeEventListener("online", goOnline);
      window.removeEventListener("offline", goOffline);
      window.removeEventListener("gs-queue-change", refresh);
    };
  }, []);

  if (!offline && !pending && !syncing) return null;

  return (
    <div
      className={`sticky top-0 z-40 flex items-center justify-between gap-3 px-4 py-2 text-xs font-semibold uppercase tracking-wider ${
        offline ? "bg-foreground text-background" : "bg-primary text-primary-foreground"
      }`}
      data-testid="offline-bar"
    >
      <span className="flex items-center gap-2">
        {offline ? <CloudOff className="h-4 w-4" /> : syncing ? <RefreshCcw className="h-4 w-4 animate-spin" /> : <Check className="h-4 w-4" />}
        {offline
          ? `Offline — lavori salvati sul dispositivo${pending ? ` (${pending} in attesa)` : ""}`
          : syncing
          ? "Sincronizzazione in corso…"
          : `${pending} modifiche da sincronizzare`}
      </span>
      {!offline && pending > 0 && (
        <button
          type="button"
          className="underline"
          onClick={async () => {
            setSyncing(true);
            await flushQueue();
            setSyncing(false);
            setPending(pendingCount());
          }}
          data-testid="sync-now-btn"
        >
          Sincronizza ora
        </button>
      )}
    </div>
  );
};
